import { render } from "./ListChild.vue?vue&type=template&id=350b6b04&scoped=true&ts=true"
import script from "./ListChild.vue?vue&type=script&lang=ts"
export * from "./ListChild.vue?vue&type=script&lang=ts"

import "./ListChild.vue?vue&type=style&index=0&id=350b6b04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350b6b04"]])

export default __exports__